import { coursetranchesApi } from "api/courseTranchesApi";
import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";

export const useCourseTranches = (courseId?: string | number) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_TRANCHES(courseId!),
    queryFn: () => coursetranchesApi.fetchByCourseId(Number(courseId)),
    enabled: !!courseId,
  });

  return { isLoading, data: data?.data?.data ?? [], isReady: data?.data.isReady, refetch };
};

export const useCourseTranchesOptions = (courseId?: string | number) => {
  const { isLoading, data } = useCourseTranches(courseId);

  const options = data.map((x) => ({
    value: x.id.toString(),
    label: x.name,
    tranche: x,
  }));

  return { isLoading, options };
};
